import normalizeBooleanFlag from "./normalizeBooleanFlag.mjs";

const ACTIVE_SUBSCRIPTION_STATUSES = ["active", "trialing", "past_due", "unpaid"];

export default function orderingTableModuleAvailability(subscriptions) {
    const normalizedSubscriptions = Array.isArray(subscriptions)
        ? subscriptions
        : subscriptions && typeof subscriptions === "object"
          ? Object.values(subscriptions)
          : [];

    const clickAndCollectSubscriptions = normalizedSubscriptions.filter((subscription) => {
        return (
            ACTIVE_SUBSCRIPTION_STATUSES.includes(subscription?.status) &&
            subscription?.module?.type === "click-and-collect" &&
            (subscription?.restaurant_id ?? subscription?.restaurant?.id) != null
        );
    });

    return {
        available: clickAndCollectSubscriptions.length > 0,
        enabled: clickAndCollectSubscriptions.some((subscription) => {
            return normalizeBooleanFlag(subscription?.restaurant?.feat_ordering_table);
        }),
    };
}
